import React from 'react'
import Banner from '../components/banner/Banner'
import CoinsTable from '../components/CoinsTable'


const HomePage = () => {
  return (
    <>
    <Banner/>
    <CoinsTable/>
    </>
  )
}

export default HomePage